import axios from "axios";
import moment from "moment";
import {
  aggregateMealsByDay,
  getFinalKcalAndPercentage,
} from "../../../helpers/mealsHelper";
import i18n from "../../../i18n";
import { DEFAULT_MOMENT_LOCALE } from "../../../i18n/helpers";
import {
  DateFormat,
  getExtendedDateFormat,
  UNIT,
} from "../../../modules/constants";
import { handleHttpErrors } from "../../../modules/http";

// Constants
const SET_CHART_DATA = "SET_CHART_DATA";

//Acessors
const getTotalItems = (state) => state?.totalItems;
const getEntries = (state) => state?.entries;

// Default State
const defaultState = {
  entries: [],
  totalItems: null,
};

//Reducer
export const studyLineChartReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_CHART_DATA: {
      const { chartData } = action;
      return Object.assign({}, state, {
        entries: chartData.total,
        totalItems: chartData.totalEntries,
      });
    }
    default:
      return state;
  }
};

const fetchLineChartData =
  (startDate, endDate, participantId = null) =>
  (dispatch) => {
    const params = {
      limit: 9999,
      StartDate: startDate,
      EndDate: endDate,
    };

    if (participantId) {
      params.ParticipantId = participantId;
    }

    return axios
      .get("/api/diet/userinfo/entries", { params })
      .then(({ data: { entries } }) => {
        dispatch({
          type: SET_CHART_DATA,
          chartData: parseChartData(entries, startDate, endDate),
        });
        return Promise.resolve();
      })
      .catch((error) => {
        return handleHttpErrors(error.request?.status, {
          default: i18n.t("errorText.dietDiary.entries.get"),
        });
      });
  };

const getDates = (startDate, endDate) => {
  const dateArray = [];
  let currentDate = moment(startDate);
  while (currentDate <= endDate) {
    dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
    currentDate = moment(currentDate).add(1, "d");
  }
  return dateArray;
};

const parseChartData = (data, startDate, endDate) => {
  const { total, totalEntries } = data;

  const formattedData = aggregateMealsByDay(total);

  const kcalObj = getFinalKcalAndPercentage(formattedData);

  const dateRange = getDates(new Date(startDate), new Date(endDate));

  const emptyData = [];
  const defaultData = {
    percentage: 0,
    value: 0,
    unit: UNIT.DEFAULT,
  };
  dateRange.forEach(function (date) {
    const emptyDayData = {
      meals: [],
      protein: defaultData,
      calories: defaultData,
      carbohydrates: defaultData,
      mediumChainFats: defaultData,
      longChainFats: defaultData,
      date: moment(date).format(getExtendedDateFormat()),
      dateDefaultLocale: moment(date)
        .locale(DEFAULT_MOMENT_LOCALE)
        .format(DateFormat.EXTENDED_FORMAT),
    };
    emptyData.push(emptyDayData);
  });
  // After getting all the dates between startDate and endDate, fill each day with defaultData
  // and then replace each non empty day with respective meal data by date
  const dateRangeData = Object.values(
    [].concat(emptyData, kcalObj).reduce((r, c) => {
      r[c.dateDefaultLocale] = Object.assign(r[c.dateDefaultLocale] || {}, c);
      return r;
    }, {})
  );

  return { total: dateRangeData, totalEntries };
};

// Maps
export const mapDispatchToProps = {
  fetchLineChartData,
};

export const mapStateToProps = (state) => {
  return {
    totalItems: getTotalItems(state),
    entries: getEntries(state),
  };
};
